import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { AxiosError } from 'axios';

import { useCustomToast } from 'hooks';
import { postSendInvoiceToEmail } from 'modules/_common/api';

export const useMutationSendInvoiceToEmail = () => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(postSendInvoiceToEmail, {
    onSuccess: () => {
      successToast(t('Email sent successfully'));
    },
    onError: (error: AxiosError) => {
      const errorMessage = error.response?.data as { ErrorDescription: string };
      errorToast(errorMessage?.ErrorDescription);
    },
  });
};
